import axios from 'axios';
import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";

import homeRoutes from "./routes/index";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'font-awesome/css/font-awesome.min.css';


import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import './style.css';
import './custome_style.css';

import { captureAttribution } from './utils/attribution';
import * as Sentry from "@sentry/react";



Sentry.init({
    dsn: "https://382b842b8aed1837e8180b6eee908da2@o4511817465987072.ingest.de.sentry.io/4511817476472912",

    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({
            levels: ["log", "warn", "error"],
        }),
    ],

    tracesSampleRate: 1.0,
    enableLogs: true,
});

function App() {

    useEffect(() => {
        //fetch source Attribute
        captureAttribution();

        //adding lazy loading for images
        // const enableLazyLoading = () => {
        //     document.querySelectorAll("img:not([loading])").forEach((img) => {
        //         img.setAttribute("loading", "lazy");
        //         img.setAttribute("decoding", "async");
        //     });
        // };
        // enableLazyLoading();
        
        // const imageObserver = new MutationObserver(() => {
        //     enableLazyLoading();
        // });

        // imageObserver.observe(document.body, {
        //     childList: true,
        //     subtree: true,
        // });


        
        // let newUrl = window.location.href;

        // if (!newUrl.includes("www.")) {
        //     // console.log("first+++");
        //     newUrl = newUrl.replace("https://", "https://www.");
        // }

        // if (newUrl !== window.location.href) {
        //     window.location.replace(newUrl);
        //     // console.log("reloadd+++");

        // }
        
        fetchNonceData();
    }, []);


    const fetchNonceData = async () => {
        try {
            const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

            let config = {
                method: 'get',
                url: `${mainUrl}/api/getNonceData`
            };
            axios.request(config)
                .then((response) => {
                    // console.log('response.data++++++++++++++++',response.data);
                    localStorage.setItem('nonce', response.data.message ? response.data.message.nonce : "");
                })
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <BrowserRouter>
            <Routes>
                {homeRoutes.map((itm, idx) => {
                    return (<Route path={itm.path} element={<itm.component />} key={idx} />)
                })}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
